export default __webpack_public_path__ + "static/media/landing-v2.eff95ac3.png";